import { createContext } from "react";
import { defaultLang } from "@/app/lang/utils";
import { ReactContextProps } from "@/app/providers/ReactContextProvider/types";

export const ReactContext = createContext<ReactContextProps>({
  loading: false,
  setLoading: () => {},
  lang: defaultLang,
  setLang: () => {},
  errorMessage: null,
  setErrorMessage: () => {},
});
